<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>
    <!--Project information -->

    <div class="ui vertical basic segment" fxLayout="column" fxLayoutGap="25px">
      <div fxLayout="column">
        <div fxFlex>
          <img
            *ngIf="application.logoPath"
            src="{{ baseUrl }}/public/image/?media={{ application.logoPath }}"
            class="ui mini image"
          />
          <img
            *ngIf="!application.logoPath"
            src="assets/avatar/1.jpg"
            class="ui circular tiny image"
          />
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex><strong>NAME</strong></div>
        <div fxFlex>{{ application?.applicationName }}</div>
      </div>

      <div fxLayout="column">
        <div fxFlex class="header"><strong>HOST</strong></div>
        <div fxFlex>{{ application?.applicationHost }}</div>
      </div>

      <div fxLayout="column">
        <div fxFlex><strong> ACCESS TYPES </strong></div>
        <div fxFlex>
          <label
            class="ui teal circular label"
            [ngClass]="{ green: application.publicAccessEnabled }"
            >{{ application?.accessTypes }}</label
          >
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex><strong>DESCRIPTION </strong></div>
        <div fxFlex>{{ application?.applicationDescription }}</div>
      </div>

      <div fxLayout="column">
        <div fxFlex><strong>HIDDEN FROM DASHBOARD </strong></div>
        <div fxFlex>
          <label
            class="ui orange circular label"
            [ngClass]="{ green: application.hideFromDashboard }"
            >{{ application?.hideFromDashboard }}</label
          >
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex><strong>APPLICATION ROLE URL</strong></div>
        <div fxFlex>{{ application?.applicationRole }}</div>
      </div>
      <div fxLayout="column">
        <div fxFlex><strong>APPLICATION PAYMENT CALLBACK URL</strong></div>
        <div fxFlex>{{ application?.paymentCallBackUrl }}</div>
      </div>

      <div fxLayout="column">
        <div fxFlex><strong>ORDERING </strong></div>
        <div fxFlex>{{ application?.ordering }}</div>
      </div>
    </div>
  </div>
</div>
<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button class="ui primary button" (click)="modal.deny(undefined)">
    Done
  </button>
</div>
